import { useQuery } from '@tanstack/react-query';
import { getMostPopularGames, type GameThumbnail } from '../services/gamePerformanceService';

export const POPULAR_GAMES_QUERY_KEY = 'popularGames';

export function usePopularGames(enabled = true) {
	return useQuery<GameThumbnail[], Error>({
		queryKey: [POPULAR_GAMES_QUERY_KEY],
		queryFn: getMostPopularGames,
		enabled,
		staleTime: 1000 * 60 * 5, // 5 minutes
		gcTime: 1000 * 60 * 10, // 10 minutes
		retry: 1,
	});
}